if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};

//#region Panel Updates

rtAPI.security.updatePanels = function (result) {
    //Setup visibility of elements
    var btnTFASelectCancel = 'none';
    var btnTFAHardwareKeyRegister = 'inherit';
    var btnTFAHardwareKeyRetry = 'inherit';
    if (!rtAPI.security.enableAccountActivation || !result.emailAccountActivationEnabled) rtAPI.displayElement(this.btn.resendAuthEmail, 'none');
    if (!rtAPI.security.enableGetUsername || !result.getUsernameEnabled) rtAPI.displayElement(this.btn.lostUsername, 'none');
    if (!rtAPI.security.enableGetPassword) rtAPI.displayElement(this.btn.lostPassword, 'none');
    if (!rtAPI.security.enableTFAManagement) {
        rtAPI.displayElement(document.querySelector(`label[for='${this.fd.manageTFA.id}']`), 'none');
        rtAPI.displayElement(rtAPI.btn.tFAManageBack, 'none');
    }


    //Setup pnls
    var pnlLogin = 'none';
    var pnlLogout = 'none';
    var pnlTFASelect = 'none';
    var pnlTFACode = 'none';
    var pnlTFAMemorableData = 'none';
    var pnlTFAHardwareKey = 'none';
    var pnl2FAManage = 'none';

    switch (result.loginPanelMode) {
        case "Logout":
            pnlLogout = 'inherit';
            rtAPI.security.tFASelectModeTriggered = false;
            rtAPI.security.clearFields();
            if (rtAPI.security.showTFAManagement) pnl2FAManage = '';
            rtAPI.security.tFAData = result.tFAData;
            rtAPI.security.init2FAManagePanel();
            break;

        case "Login":
            pnlLogin = 'inherit';
            rtAPI.security.tFASelectModeTriggered = false;
            break;

        case "2FASelect":
            btnTFASelectCancel = 'inherit';
            rtAPI.security.init2FASelectPanel(result);
            break;

        case "2FACode":
            pnlTFACode = 'inherit';
            rtAPI.security.fd.authenticationCode.value = result.code;
            break;

        case "2FAMemorableData":
            pnlTFAMemorableData = 'inherit';
            rtAPI.security.init2FAMemorableDataPanel(result);
            break;

        case "2FAHardwareKey":
            pnlTFAHardwareKey = 'inherit';
            if (rtAPI.security.fireTFAHardwareKeyLoginWhenSelected) {
                rtAPI.security.fireTFAHardwareKeyLoginWhenSelected = false;
                btnTFAHardwareKeyRegister = 'none';
                btnTFAHardwareKeyRetry = 'none';
                rtAPI.security.hardwareKey.triggerLogin()
                    .then(success => { if (success) return; })
            }
            rtAPI.displayElement(this.btn.tFAHardwareKeyRegister, btnTFAHardwareKeyRegister);
            rtAPI.displayElement(this.btn.tFAHardwareKeyRetry, btnTFAHardwareKeyRetry);
            break;
    }

    this.btn.tFASelectCancel.style.display = btnTFASelectCancel;
    if (rtAPI.security.tFASelectModeTriggered) pnlTFASelect = 'inherit';
    else rtAPI.security.renderedTFAOptions = "";

    //Do callback
    if (typeof this.panelUpdateCallback === 'function') {
        result.abortPanelUpdate = false;
        this.panelUpdateCallback(result);
        if (result.abortPanelUpdate) return;
    }

    //Update displayed panels
    rtAPI.displayElement(this.pnl.login, pnlLogin);
    rtAPI.displayElement(this.pnl.logout, pnlLogout);
    rtAPI.displayElement(this.pnl.tFASelect, pnlTFASelect);
    rtAPI.displayElement(this.pnl.tFACode, pnlTFACode);
    rtAPI.displayElement(this.pnl.tFAMemorableData, pnlTFAMemorableData);
    rtAPI.displayElement(this.pnl.tFAHardwareKey, pnlTFAHardwareKey);
    if (rtAPI.security.enableTFAManagement) rtAPI.displayElement(this.pnl.dialog, pnl2FAManage);

}

//#endregion

//#region 2FA Select Panel

rtAPI.security.init2FASelectPanel = function (result) {
    rtAPI.security.tFASelectModeTriggered = true;
    if (JSON.stringify(result.tFAData.options) != JSON.stringify(rtAPI.security.renderedTFAOptions)) {
        rtAPI.security.renderedTFAOptions = result.tFAData.options;
        rtAPI.security.pnl.tFASelectOptions.innerHTML = '';
        for (const item of result.tFAData.options) {
            if (!item.enabled) continue;
            if (!item.interactive) continue;
            //var spanElement = document.createElement('span');
            //rtAPI.security.pnl.tFASelectOptions.appendChild(spanElement);

            //var inputElement = document.createElement('input');
            //spanElement.appendChild(inputElement);
            //inputElement.id = `tFAOption${item.method}`;
            //inputElement.type = 'radio'
            //inputElement.name = 'tFAOptions';
            //inputElement.value = `${item.method}`;
            //inputElement.setAttribute('sid-key', `pnl-two-factor-authentication-select-options-${item.method.toLowerCase()}`);
            //inputElement.addEventListener('click', this.handle.sendSelect2FAMethod);

            //var labelElement = document.createElement('label');
            //spanElement.appendChild(labelElement);
            //labelElement.setAttribute('for', `tFAOption${item.method}`);
            //labelElement.innerHTML = `${item.titleUse}`;
        }
    }
}

//#endregion

//#region 2FA Memorable Data Panel

rtAPI.security.init2FAMemorableDataPanel = function (result) {
    rtAPI.security.pnl.tFAMemorableDataFields.innerHTML = '';
    if (result.memorableDataHintVisible) {
        var hintElement = document.createElement('span');
        rtAPI.security.pnl.tFAMemorableDataFields.appendChild(hintElement);
        hintElement.id = 'pnl2FAMemorableDataHint';
        hintElement.innerHTML = `<span class="memorable-data-hint-title">${result.memorableDataHintTitle}</span><span class="memorable-data-hint-text">${result.memorableDataHintText}</span>`;
    }
    var fields = [result.memorableDataLabel1, result.memorableDataLabel2, result.memorableDataLabel3];
    var counter = 1
    fields.forEach(function (item) {
        var fieldsElement = document.createElement('span');
        fieldsElement.id = `pnlmemorableData${counter}`;
        fieldsElement.className = 'pnlmemorableData';
        rtAPI.security.pnl.tFAMemorableDataFields.appendChild(fieldsElement);

        var labelElement = document.createElement('label');
        fieldsElement.appendChild(labelElement);
        labelElement.setAttribute('for', `memorableData${counter}`);
        labelElement.innerHTML = `${item}`;

        var inputElement = document.createElement('input');
        fieldsElement.appendChild(inputElement);
        inputElement.id = `memorableData${counter}`;
        inputElement.type = 'password'
        inputElement.setAttribute('autocomplete', 'new-password');
        inputElement.maxLength = 1;
        inputElement.setAttribute('requiredGroup', 'requiredGroupMemorableData');
        inputElement.setAttribute('requiredErrorMessage', eval(`result.memorableDataErrorMessage${counter}`));
        inputElement.setAttribute('sid-key', `pnl-two-factor-authentication-memorable-data-${counter}`);
        counter++;
    })
    document.getElementById('memorableData1').addEventListener('input', function () { rtAPI.security.init2FAMemorableDataPanelAutoTab(this, document.getElementById('memorableData2')) });
    document.getElementById('memorableData2').addEventListener('input', function () { rtAPI.security.init2FAMemorableDataPanelAutoTab(this, document.getElementById('memorableData3')) });
}

rtAPI.security.init2FAMemorableDataPanelAutoTab = function (current, to) {
    if (current.getAttribute && current.value.length == current.getAttribute("maxlength")) to.focus();
}

//#endregion

//#region 2FA Manage Panel

rtAPI.security.init2FAManagePanel = function () {
    rtAPI.messages.targetSuffix = '';
    if (!rtAPI.security.showTFAManagement) return;
    rtAPI.messages.targetSuffix = 'MFM';
    if (rtAPI.security.pnl.dialogFields.innerHTML != '') return;

    for (const option of rtAPI.security.tFAData.options) {
        var rowElement = document.createElement('div');
        rowElement.className = 'tFAManageOptionRow';
        rtAPI.security.pnl.dialogFields.appendChild(rowElement);

        var spanElement = document.createElement('span');
        spanElement.className = 'switch-toggle';
        rowElement.appendChild(spanElement);

        var inputElement = document.createElement('input');
        spanElement.appendChild(inputElement);
        inputElement.id = `tFAManageOption${option.method}`;
        inputElement.className = 'tFAManageOptionCheckbox';
        inputElement.type = 'checkbox'
        inputElement.checked = option.enabled;
        inputElement.value = `${option.method}`;
        inputElement.setAttribute('sid-key', `pnl-two-factor-authentication-manage-options-${option.method.toLowerCase()}`);
        inputElement.addEventListener('click', rtAPI.security.handle.tFAManageOptionToggle);

        var labelElement = document.createElement('label');
        spanElement.appendChild(labelElement);
        labelElement.id = `tFAManageOptionImage${option.method}`;
        labelElement.className = 'tFAManageOptionImage';
        labelElement.setAttribute('for', `tFAManageOption${option.method}`);

        var labelTextElement = document.createElement('label');
        spanElement.appendChild(labelTextElement);
        labelTextElement.id = `tFAManageOptionText${option.method}`;
        labelTextElement.className = 'tFAManageOptionText';
        labelTextElement.setAttribute('for', `tFAManageOption${option.method}`);
        labelTextElement.innerHTML = `${option.titleEnable}`;

        if (option.buttonAction != '') {
            var spanButtonElement = document.createElement('span');
            spanButtonElement.className = 'button-span';
            rowElement.appendChild(spanButtonElement);

            var buttonElement = document.createElement('button');
            spanButtonElement.appendChild(buttonElement);
            buttonElement.id = `tFAManageOptionButton${option.method}`;
            buttonElement.innerText = option.buttonText;
            buttonElement.className = 'button button-TFA button-manage';
            if (!option.enabled && !option.alwaysShowButton) buttonElement.style.display = 'none';
            eval(`buttonElement.addEventListener('click', rtAPI.security.handle.tFAManageOption${option.buttonAction})`);
        }
    }

    for (const option of rtAPI.security.tFAData.options) {
        for (const field of option.fields) {
            rtAPI.security.create2FAManageUpdatePanelField(field);
        }
    }

    rtAPI.displayElement(this.btn.tFAManageHardwareKeyAdd, 'none');
    rtAPI.displayElement(this.btn.tFAManageBack, 'none');
    rtAPI.displayElement(this.btn.tFAManageClose, 'inline-block');
    rtAPI.security.create2FAManageUpdatePanelField(rtAPI.security.tFAData.password);
    rtAPI.security.update2FAManagePanel();
}

rtAPI.security.create2FAManageUpdatePanelField = function (field) {
    var spanElement = document.createElement('span');
    spanElement.id = field.pnlId;
    spanElement.className = 'tfa-manage-field';
    rtAPI.security.pnl.dialogFields.appendChild(spanElement);

    var labelTextElement = document.createElement('label');
    spanElement.appendChild(labelTextElement);
    labelTextElement.innerHTML = field.titleField;
    labelTextElement.setAttribute('for', field.id);

    var inputElement = document.createElement('input');
    spanElement.appendChild(inputElement);
    inputElement.id = field.id;
    inputElement.type = field.type.toLowerCase();
    inputElement.value = field.value;
    inputElement.setAttribute('autocomplete', 'new-password');
    inputElement.setAttribute('sid-key', `tfa-manage-field-${field.id}`);
    inputElement.addEventListener('input', rtAPI.security.handle.tFAManageFieldInput);
    for (const validator of field.validators) {
        switch (validator.validationType) {
            case "Required":
                if (field.initialValue != '') inputElement.setAttribute(validator.validationType.toLowerCase(), validator.parameter);
                continue;

            default:
                inputElement.setAttribute(validator.validationType.toLowerCase(), validator.parameter);
                break;
        }
    }
}

rtAPI.security.update2FAManagePanel = function () {
    rtAPI.security.btn.tFAManageUpdate.style.display = rtAPI.security.tFAManageOptionsChanged() ? '' : 'none';
    rtAPI.security.update2FAManageField(rtAPI.security.tFAData.password, rtAPI.security.tFAManageOptionsChanged());

    for (const option of rtAPI.security.tFAData.options) {
        var targetSwitch = document.getElementById(`tFAManageOption${option.method}`);
        targetSwitch.checked = option.newState;
        for (const field of option.fields) {
            rtAPI.security.update2FAManageField(field, option.newState);
        }
        if (option.buttonAction != '') {
            let buttonManageVisible = ((option.enabled == option.newState && option.newState) || option.alwaysShowButton);
            document.getElementById(`tFAManageOptionButton${option.method}`).style.display = buttonManageVisible ? 'inline-block' : 'none';
        }
    }
    //rtAPI.security.tFAManageUpdateMessagesUpdate();
}

rtAPI.security.update2FAManageField = function (field, enabled) {
    document.getElementById(field.pnlId).style.display = enabled ? '' : 'none';
    var targetInput = document.getElementById(field.id);
    if (field.value != targetInput.value) targetInput.value = field.value; //Used to resync data after api call 

    for (const validator of field.validators) {
        switch (validator.validationType) {
            case "Required":
                if (enabled) {
                    if (field.initialValue != '') targetInput.setAttribute('required', '');
                }
                else targetInput.removeAttribute('required');
                return;

            default:
                continue;
        }
    }

}

rtAPI.security.tFAManageOptionsChanged = function () {
    if (!rtAPI.security.showTFAManagement) return false;
    if (rtAPI.security.pnl.dialogFields.innerHTML == '') return false;

    for (const option of rtAPI.security.tFAData.options) {
        if (option.enabled == option.newState && !rtAPI.security.tFAManageOptionFieldsChanged(option)) continue;
        return true;
    }
    return false;
}

rtAPI.security.tFAManageOptionFieldsChanged = function (option) {
    if (!rtAPI.security.showTFAManagement) return false;
    if (rtAPI.security.pnl.dialogFields.innerHTML == '') return false;

    for (const field of option.fields) {
        if (field.value == field.initialValue) continue;
        return true;
    }
    return false;
}

rtAPI.security.tFAManageOptionsAreValid = function () {
    var isValid = true;
    if (!rtAPI.security.tFAManageFieldIsValid(rtAPI.security.tFAData.password)) isValid = false;
    for (const option of rtAPI.security.tFAData.options) {
        if (!option.newState) continue;
        for (const field of option.fields) {
            if (!rtAPI.security.tFAManageFieldIsValid(field)) isValid = false;
        }
    }
    return isValid;
}

rtAPI.security.tFAManageFieldIsValid = function (field) {
    var targetInput = document.getElementById(field.id);
    for (const validator of field.validators) {
        switch (validator.validationType) {
            case "Required":
                targetInput.setAttribute('required', '');
                if (!targetInput.validity.valueMissing) continue;
                targetInput.reportValidity();
                //rtAPI.security.tFAManageUpdateErrorMessageSet(validator.errorMessage, true);
                rtAPI.messages.addCritical(validator.errorMessage, true);
                return false;

            case "MinLength":
                if (!targetInput.validity.tooShort) continue;
                targetInput.reportValidity();
                //rtAPI.security.tFAManageUpdateErrorMessageSet(validator.errorMessage, true);
                rtAPI.messages.addCritical(validator.errorMessage, true);
                return false;

            case "Pattern":
                if (!targetInput.validity.patternMismatch) continue;
                targetInput.reportValidity();
                //rtAPI.security.tFAManageUpdateErrorMessageSet(validator.errorMessage, true);
                rtAPI.messages.addCritical(validator.errorMessage, true);
                return false;
        }
    }
    return true;
}


//#endregion

//#region 2FA Manage HardwareKey Panel

rtAPI.security.init2FAManageHardwareKeyPanel = function () {
    if (!rtAPI.security.showTFAManagement) return;

    rtAPI.security.pnl.dialogFields.innerHTML = '';
    const mHK = rtAPI.security.tFAData.manageTFAHardwareKey;
    var rowH3Element = document.createElement('h3');
    rowH3Element.className = 'tFAManageHardwareKeyPanelTitle';
    rowH3Element.innerText = mHK.title;
    rtAPI.security.pnl.dialogFields.appendChild(rowH3Element);

    var tableElement = document.createElement('div');
    tableElement.className = 'tFAManageOptionTable';
    rtAPI.security.pnl.dialogFields.appendChild(tableElement);

    var rowHElement = document.createElement('div');
    rowHElement.className = 'tFAManageOptionRow tFAHeader';
    tableElement.appendChild(rowHElement);

    var spanHUserIdentElement = document.createElement('span');
    spanHUserIdentElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyUserIdent';
    spanHUserIdentElement.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[0];
    rowHElement.appendChild(spanHUserIdentElement);

    var spanHButtonElement = document.createElement('span');
    spanHButtonElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyStatusText';
    spanHButtonElement.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[1];
    rowHElement.appendChild(spanHButtonElement);

    for (const hardwareKey of mHK.hardwareKeys) {
        var rowElement = document.createElement('div');
        rowElement.className = 'tFAManageOptionRow';
        tableElement.appendChild(rowElement);

        var spanUserIdentElement = document.createElement('span');
        spanUserIdentElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyUserIdent';
        spanUserIdentElement.innerText = hardwareKey.UserIdent;
        rowElement.appendChild(spanUserIdentElement);

        var spanButtonElement = document.createElement('span');
        spanButtonElement.className = 'tFAManageOptionCell button-span';
        rowElement.appendChild(spanButtonElement);

        if (hardwareKey.Authorised) {
            var spanAuthorisedElement = document.createElement('span');
            spanAuthorisedElement.className = 'tFAManageOptionHardwareKeyStatus';
            spanAuthorisedElement.innerText = rtAPI.security.tFAData.text.hardwareKeyAuthorised;
            spanButtonElement.appendChild(spanAuthorisedElement);
        }
        else {
            var buttonAuthoriseElement = document.createElement('button');
            spanButtonElement.appendChild(buttonAuthoriseElement);
            buttonAuthoriseElement.id = `tFAManageOptionHardwareKeyAuthorise${hardwareKey.Id}`;
            buttonAuthoriseElement.idDB = hardwareKey.Id;
            buttonAuthoriseElement.userIdent = hardwareKey.UserIdent;
            buttonAuthoriseElement.className = 'button button-TFA button-authorise';
            buttonAuthoriseElement.innerText = rtAPI.security.tFAData.text.hardwareKeyAuthorise;
            buttonAuthoriseElement.addEventListener('click', rtAPI.security.handle.tFAManageAuthorise);
        }

        if (mHK.allowRemove) {
            var buttonRemoveElement = document.createElement('button');
            spanButtonElement.appendChild(buttonRemoveElement);
            buttonRemoveElement.id = `tFAManageOptionHardwareKeyRemove${hardwareKey.Id}`;
            buttonRemoveElement.idDB = hardwareKey.Id;
            buttonRemoveElement.userIdent = hardwareKey.UserIdent;
            buttonRemoveElement.innerText = rtAPI.security.tFAData.text.hardwareKeyRemove;
            buttonRemoveElement.className = 'button button-TFA button-remove';
            buttonRemoveElement.addEventListener('click', rtAPI.security.handle.tFAManageRemove);
        }

    }
    rtAPI.displayElement(this.btn.tFAManageHardwareKeyAdd, 'inline-block');
    rtAPI.displayElement(this.btn.tFAManageBack, 'inline-block');
    rtAPI.displayElement(this.btn.tFAManageClose, 'none');
}

rtAPI.security.updateManageHardwareKeyPanels = function (result) {
    rtAPI.security.tFAData = result.tFAData;
    rtAPI.security.init2FAManageHardwareKeyPanel();
}

//#endregion

//#region 2FA Manage AuthorisedDevice Panel

rtAPI.security.init2FAManageAuthorisedDevicePanel = function () {
    if (!rtAPI.security.showTFAManagement) return;

    rtAPI.security.pnl.dialogFields.innerHTML = '';
    const mAD = rtAPI.security.tFAData.manageTFAAuthorisedDevice;
    var rowH3Element = document.createElement('h3');
    rowH3Element.className = 'tFAManageAuthorisedDevicePanelTitle';
    rowH3Element.innerText = mAD.title;
    rtAPI.security.pnl.dialogFields.appendChild(rowH3Element);

    if (mAD.authorisedDevices.length == 0) {
        var tableElement = document.createElement('div');
        tableElement.className = 'tFAManageOptionEmptyTable';
        tableElement.innerHTML = rtAPI.security.tFAData.text.noDevices;
        rtAPI.security.pnl.dialogFields.appendChild(tableElement);
        return;
    }

    var tableElement = document.createElement('div');
    tableElement.className = 'tFAManageOptionTable';
    rtAPI.security.pnl.dialogFields.appendChild(tableElement);

    var rowHElement = document.createElement('div');
    rowHElement.className = 'tFAManageOptionRow tFAHeader';
    tableElement.appendChild(rowHElement);

    var spanHUserIdentElementBrowser = document.createElement('span');
    spanHUserIdentElementBrowser.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceBrowser';
    spanHUserIdentElementBrowser.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[0];
    rowHElement.appendChild(spanHUserIdentElementBrowser);

    var spanHUserIdentElementDescription = document.createElement('span');
    spanHUserIdentElementDescription.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceDescription';
    spanHUserIdentElementDescription.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[1];
    rowHElement.appendChild(spanHUserIdentElementDescription);

    var spanHUserIdentElementIPAddress = document.createElement('span');
    spanHUserIdentElementIPAddress.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceIPAddress';
    spanHUserIdentElementIPAddress.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[2];
    rowHElement.appendChild(spanHUserIdentElementIPAddress);

    var spanHUserIdentElementLoginCounter = document.createElement('span');
    spanHUserIdentElementLoginCounter.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceLoginCounter';
    spanHUserIdentElementLoginCounter.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[3];
    rowHElement.appendChild(spanHUserIdentElementLoginCounter);

    if (mAD.enabled) {
        var spanHButtonElement = document.createElement('span');
        spanHButtonElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyStatusText';
        spanHButtonElement.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[4];
        rowHElement.appendChild(spanHButtonElement);
    }

    for (const authorisedDevice of mAD.authorisedDevices) {
        var rowElement = document.createElement('div');
        rowElement.className = 'tFAManageOptionRow';
        tableElement.appendChild(rowElement);

        var spanUserIdentElementBrowser = document.createElement('span');
        spanUserIdentElementBrowser.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceBrowser';
        spanUserIdentElementBrowser.innerText = authorisedDevice.Browser;
        rowElement.appendChild(spanUserIdentElementBrowser);

        var spanUserIdentElementDescription = document.createElement('span');
        spanUserIdentElementDescription.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceDescription';
        spanUserIdentElementDescription.innerText = authorisedDevice.Description;
        rowElement.appendChild(spanUserIdentElementDescription);

        var spanUserIdentElementIPAddress = document.createElement('span');
        spanUserIdentElementIPAddress.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceIPAddress';
        spanUserIdentElementIPAddress.innerText = authorisedDevice.IPAddress;
        rowElement.appendChild(spanUserIdentElementIPAddress);

        var spanUserIdentElementLoginCounter = document.createElement('span');
        spanUserIdentElementLoginCounter.className = 'tFAManageOptionCell tFAManageOptionAuthorisedDeviceLoginCounter';
        spanUserIdentElementLoginCounter.innerText = authorisedDevice.LoginCounter;
        rowElement.appendChild(spanUserIdentElementLoginCounter);

        var spanButtonElement = document.createElement('span');
        spanButtonElement.className = 'tFAManageOptionCell button-span';
        rowElement.appendChild(spanButtonElement);

        if (mAD.enabled) {
            if (authorisedDevice.Activated) {
                var spanAuthorisedElement = document.createElement('span');
                spanAuthorisedElement.className = 'tFAManageOptionAuthorisedDeviceStatus';
                spanAuthorisedElement.innerText = rtAPI.security.tFAData.text.deviceAuthorised;
                spanButtonElement.appendChild(spanAuthorisedElement);
            }
            else {
                var buttonAuthoriseElement = document.createElement('button');
                spanButtonElement.appendChild(buttonAuthoriseElement);
                buttonAuthoriseElement.id = `tFAManageOptionAuthorisedDeviceAuthorise${authorisedDevice.Id}`;
                buttonAuthoriseElement.idDB = authorisedDevice.Id;
                buttonAuthoriseElement.name = authorisedDevice.Name;
                buttonAuthoriseElement.className = 'button button-TFA button-authorise';
                buttonAuthoriseElement.innerText = rtAPI.security.tFAData.text.deviceAuthorise;
                buttonAuthoriseElement.addEventListener('click', rtAPI.security.handle.tFAManageAuthorisedDeviceAuthorise);
            }
        }

        var buttonRemoveElement = document.createElement('button');
        spanButtonElement.appendChild(buttonRemoveElement);
        buttonRemoveElement.id = `tFAManageOptionAuthorisedDeviceRemove${authorisedDevice.Id}`;
        buttonRemoveElement.idDB = authorisedDevice.Id;
        buttonRemoveElement.name = authorisedDevice.Name;
        buttonRemoveElement.innerText = rtAPI.security.tFAData.text.deviceRemove;
        buttonRemoveElement.className = 'button button-TFA button-remove';
        buttonRemoveElement.addEventListener('click', rtAPI.security.handle.tFAManageAuthorisedDeviceRemove);

    }
    rtAPI.displayElement(this.btn.tFAManageHardwareKeyAdd, 'none');
    rtAPI.displayElement(this.btn.tFAManageBack, 'inline-block');
    rtAPI.displayElement(this.btn.tFAManageClose, 'none');
}

rtAPI.security.updateManageAuthorisedDevicePanels = function (result) {
    rtAPI.security.tFAData = result.tFAData;
    rtAPI.security.init2FAManageAuthorisedDevicePanel();
}

//#endregion

